import {
    SUBMIT_CLAIM_REQUEST,
    SUBMIT_CLAIM_SUCCESS,
    SUBMIT_CLAIM_ERROR
  } from "./SubmitClaimTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    claimSubmitResponse: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SUBMIT_CLAIM_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case SUBMIT_CLAIM_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          claimSubmitResponse: action.payload,
          successMessage: "Claim submitted successfully! Please wait while redirecting...",
          errorMessage: ""
        };
      case SUBMIT_CLAIM_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          claimSubmitResponse: [],
          successMessage: "",
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  